export const data = [
  ["Hyper Engine", "home", "beta"],
  ["legal stuff", "terms", "privacy"],
  ["company", "about", "jobs"]
];
